export default "__VITE_ASSET__2d9c29da__"